// extracted by mini-css-extract-plugin
module.exports = {"link":"C3ch","header":"C3ap"};